<template>
  <div class="wrapper">
    <div>
      <el-card>
        <div class="data_list">
          <ul>
            <li>
              <div>
                {{dataForm.activityName}}
                <span
                  v-if="dataForm.auditStatus == 0"
                >{{$t("crs.task.auditStatus0")}}</span>
                <span v-else-if="dataForm.auditStatus == 1">{{$t("crs.task.auditStatus1")}}</span>
                <span v-else-if="dataForm.auditStatus == 2">{{$t("crs.task.auditStatus2")}}</span>
                <span v-else-if="dataForm.auditStatus == 3">{{$t("crs.task.auditStatus3")}}</span></div>

              <span> {{dataForm.startDate}}</span>
              -
              <span> {{dataForm.endDate}}</span>
            </li>
          </ul>
          <ul>
            <li>
              <div>{{dataForm.participationTotal}}</div>
              <span> {{$t("crs.task.participationTotal")}}</span>
            </li>
            <li>
              <div>{{dataForm.awardUserTotal}}</div>
              <span>{{$t("crs.task.awardUserTotal")}}</span>
            </li>
            <li>
              <div>{{dataForm.acceptTheRate}}</div>
              <span>{{$t("crs.task.acceptTheRate")}}</span>
            </li>
            <li>
              <div>{{dataForm.rewardAmount}}</div>
              <span>{{$t("crs.task.reward")}}</span>
            </li>
            <li>
              <div>{{dataForm.getRewardAmount}}</div>
              <span>{{$t("crs.task.getRewardAmount")}}</span>
            </li>
          </ul>
        </div>
      </el-card>
    </div>

    <FORM v-show="activeName == 'first'" ref="childForm1" @formclick="formclick1" :formData="formData1"></FORM>
    <FORM v-show="activeName == 'second'" ref="childForm2" @formclick="formclick2" :formData="formData2"></FORM>
    <FORM v-show="activeName == 'third'" ref="childForm3" @formclick="formclick3" :formData="formData3"></FORM>
    <FORM v-show="activeName == 'four'" ref="childForm4" @formclick="formclick4" :formData="formData4"></FORM>

    <el-tabs v-model="activeName" @tab-click="handleClick" style="margin: auto 20px">
      <el-tab-pane :label="$t('crs.task.participateUser')" name="first"></el-tab-pane>
      <el-tab-pane :label="$t('crs.task.granRecord')" name="second"></el-tab-pane>
      <el-tab-pane :label="$t('crs.task.blacklist')" name="third"></el-tab-pane>
      <el-tab-pane :label="$t('crs.task.userAssign')" name="four"></el-tab-pane>
    </el-tabs>

    <table-page v-show="activeName == 'first'" ref="childTable1" @btnclick="bthClick1"
                :pageData="pageData1"></table-page>
    <table-page v-show="activeName == 'second'" ref="childTable2" @btnclick="bthClick2"
                :pageData="pageData2"></table-page>
    <table-page v-show="activeName == 'third'" ref="childTable3" @btnclick="bthClick3"
                :pageData="pageData3"></table-page>
    <table-page v-show="activeName == 'four'" ref="childTable4" @btnclick="bthClick4"
                :pageData="pageData4"></table-page>

    <UPDATE ref="blacklistData" @submit="blacklistClick" :updateData="blacklistData" @uploadFile="uploadFile"></UPDATE>

    <UPDATE ref="auditUpdate" @submit="auditClick" :updateData="auditData"></UPDATE>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    import UPDATE from '@/components/page/update.vue'
    //接口地址url的统一管理
    import Qs from 'qs'
    import Url from "@/views/crs36/util/url"
    import download from '@/utils/download'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'


    let userStatus = {1: window.$t("crs.task.userStatus1"), 2: window.$t("crs.task.userStatus2"), 3:window.$t("crs.task.userStatus3"), 4:window.$t("crs.task.userStatus4"), 5: window.$t("crs.task.userStatus5")};
    let activationStatus = {0: window.$t("crs.task.activationStatus1"), 1: window.$t("crs.task.activationStatus2"), 2:window.$t("crs.task.activationStatus3")}
    let check = [];
    let activationStatus2 = {"1":  window.$t("crs.task.activationStatus21"), "2": window.$t("crs.task.activationStatus3")};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            UPDATE
        },

        created() {
            this.loadDetail();
        },
        mounted() {
        },
        methods: {
            handleClick(tab, event) {
                this.activeName = tab.name;
            },
            checkbox(rows) {
                this.check = rows;
                console.log(rows);
            },
            auditClick(row) {
                this.dataChanage(Url.task.updateUser, row, res => {
                    if (res.code == 0) {
                        this.$refs.auditUpdate.close();
                        this.$refs.childTable1.defaultGetData(this.queryData);
                        this.$message.success("suc");
                    } else {
                        this.$message.error(res.message);
                    }
                })
            },
            /*导入黑名单用户*/
            blacklistClick(row) {
                row.userList = this.user;
                row.taskActivityId = this.$route.query.activityId;
                this.dataChanage(Url.task.importBlacklist, row, res => {
                    if (res.code == 0) {
                        this.$refs.blacklistData.close();
                        this.$message.success("suc");
                    } else {
                        this.$message.error(res.message);
                    }
                })
            },
            uploadFile(col, res) {
                this.user = res.join(",");
            },
            loadDetail() {
                this.$axios.get(`${Url.task.findByActivityStatistics}/` + this.$route.query.activityId).then(res => {
                    if (res.code == 0) {
                        this.dataForm = {
                            ...this.dataForm,
                            ...res.result
                        }
                    } else {
                        this.$message.error(res.message);
                    }
                });
            },
            /*表格按钮点击事件*/
            bthClick1(clickName, row) {
            },
            /*表格按钮点击事件*/
            bthClick2(clickName, row) {
            },
            /*表格按钮点击事件*/
            bthClick3(clickName, row) {
                if (clickName == "delete") {
                    this.$axios.get(`${Url.task.deleteUserBlacklist}` + "?id=" + row.id).then(res => {
                        if (res.code == 0) {
                            this.$refs.childTable3.defaultGetData(this.queryData);
                            this.$message.success("suc");
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                }
            },
            /*表格按钮点击事件*/
            bthClick4(clickName, row) {

            },
            downloadTopicComments(data) {
                download.exportExcel(Url.wealthComment.downloadTopicComments, data, "");
            },
            /*查询表单按钮点击事件*/
            formclick1(clickName, data) {
                if (window.$t("common.search") == clickName || "查询" == clickName) {
                    this.queryData = data;
                    this.$refs.childTable1.defaultQueryData(data);
                } else if (window.$t("crs.task.export") == clickName) {
                    this.downloadUser(data);
                } else if ("修改状态" == clickName) {
                    this.$refs.auditUpdate.open(data);
                }
            },
            formclick2(clickName, data) {
                if (window.$t("common.search") == clickName || "查询" == clickName) {
                    this.queryData = data;
                    this.$refs.childTable2.defaultQueryData(data);
                } else if (window.$t("crs.task.export") == clickName) {
                    this.downloadReward(data);
                }
            },
            formclick3(clickName, data) {
                if (window.$t("common.search") == clickName || "查询" == clickName) {
                    this.queryData = data;
                    this.$refs.childTable3.defaultQueryData(data);
                } else if (window.$t("crs.task.blacklistImport") == clickName) {

                    this.$refs.blacklistData.open(data);
                }
            },
            formclick4(clickName, data) {
                if (window.$t("common.search") == clickName || "查询" == clickName) {
                    this.queryData = data;
                    this.$refs.childTable4.defaultQueryData(data);
                }
            },
            downloadUser(data) {
                download.exportExcel(Url.task.exportTaskUserActivityList, data, window.$t("crs.task.userExport"));
            },
            downloadReward(data) {
                download.exportExcel(Url.task.exportTaskUserRewardActivityList, data, window.$t("crs.task.granRecord"));
            },

            dataChanage(url, option, suc, fail) {
                this.$axios.post(url, option || {}, {headers: {'Content-Type': 'application/json'}}).then(res => {
                    this.$refs.childTable1.defaultGetData(this.queryData);
                    if (suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if (fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        data() {
            return {
                activeName: "first",
                dataForm: {
                    activityName: "",
                    startDate: "",
                    endDate: "",
                    auditStatus: 0,
                    participationTotal: 0,
                    awardUserTotal: 0,
                    acceptTheRate: 0,
                    getRewardAmount: 0,
                    rewardAmount: 0
                },
                deleteIds: "",
                pageData1: {
                    isShow: false,
                    queryUrl: Url.task.userQuery, //请求路径和参数
                    selection: false,
                    sequence: false,
                    method: "get",
                    cols: [
                        {title: "id", field: 'id', hidden: false},
                        {title:  window.$t("crs.task.customerNo"), field: 'customerNo'},
                        {title:  window.$t("crs.task.userName"), field: 'userName'},
                        {title:  window.$t("crs.task.phone"), field: 'phone'},
                        {title:  window.$t("crs.task.openAccountDate"), field: 'openAccountDate'},
                        {title: window.$t("crs.task.activationTime"), field: 'activationTime'},
                        {
                            title:  window.$t("crs.task.userStatus"), field: 'userStatus', render: (data) => {
                                return userStatus[data];
                            }
                        },
                        {
                            title:  window.$t("crs.task.getAchieveStatus"), field: 'achieveStatus', render: (data) => {
                                return activationStatus[data];
                            }
                        },
                        {title:  window.$t("crs.task.participateDate"), field: 'createDate'},
                        {title:  window.$t("crs.task.achieveDate"), field: 'achieveDate'},
                    ]
                },
                pageData2: {

                    isShow: false,
                    queryUrl: Url.task.rewardPage, //请求路径和参数
                    selection: false,
                    sequence: false,
                    method: "get",
                    cols: [
                        {title: window.$t("crs.task.orderOn"), field: 'orderOn'},
                        {title: window.$t("crs.task.userName"), field: 'userName'},
                        {title: window.$t("crs.task.customerNo"), field: 'customerNo'},
                        {title: window.$t("crs.task.phone"), field: 'phone'},
                        {title: window.$t("crs.task.openAccountDate"), field: 'openAccountDate'},
                        {title: window.$t("crs.task.activationTime"), field: 'activationTime'},
                        {
                            title: window.$t("crs.task.userStatus"), field: 'userStatus', type: 2, render: (data) => {
                                return userStatus[data];
                            }
                        },
                        {title: window.$t("crs.task.awardDate"), field: 'awardDate'},
                        {title: window.$t("crs.task.achieveDate"), field: 'achieveDate'},
                    ]
                },
                pageData3: {
                    isShow: false,
                    queryUrl: Url.task.blacklistPage, //请求路径和参数
                    selection: false,
                    sequence: false,
                    method: "get",
                    cols: [
                        {title: "id", field: 'id', hidden: false},
                        {title: window.$t("crs.task.customerNo"), field: 'customerNo'},
                        {title: window.$t("crs.task.realName"), field: 'realName'},
                        {title: window.$t("crs.task.participateDate"), field: 'createDate'},
                        {title: window.$t("crs.task.updateDate"), field: 'updateDate'},
                        {
                            title: window.$t("common.handle"), width: '100px', btnClick: [
                                {
                                    name: window.$t("common.delete"), click: "delete", type: "text"
                                }
                            ]
                        }
                    ]
                },
                pageData4: {
                    isShow: false,
                    queryUrl: Url.task.assignUserPage, //请求路径和参数
                    selection: false,
                    sequence: false,
                    method: "get",
                    cols: [
                        {title: window.$t("crs.task.customerNo"), field: 'customerNo'},
                        {title: window.$t("crs.task.realName"), field: 'realName'},
                        {title: window.$t("crs.task.participateDate"), field: 'createDate'},
                        {title: window.$t("crs.task.updateDate"), field: 'updateDate'},
                    ]
                },
                blacklistData: {
                    cols: [
                        {title: 'id', field: 'taskActivityId', hidden: true},
                        {title: 'userList', field: 'userList', hidden: true},
                        {
                            title: window.$t("common.import"),
                            field: 'users',
                            type: 11,
                            action: Url.pushMsg.uploadTemplate,
                            downUrl: "https://static.chwenda.com/source/downloadModel/user_template.xlsx"
                        },
                    ]
                },
                queryData: {},
                /*from查询表单*/
                formData1: {
                    hasLable: true,
                    cols: [
                        {title: '主键', field: 'taskActivityId', hidden: true, data: this.$route.query.activityId},
                        {title: window.$t("crs.task.customerNo"), field: 'customer'},
                        {title: window.$t("crs.task.phone"), field: 'phone'},
                        {title: window.$t("crs.task.userStatus"), field: 'userStatus', type: 2, optionList: userStatus, isNumber: true},
                        {
                            title: window.$t("crs.task.openAccountDate"), field: 'openAccountDate', type: 6,
                            isArray: true,
                            format: 'yyyy-MM-dd HH:mm:ss',
                            startEndParam: ['openAccountStartDate', 'openAccountEndDate']
                        },
                        {
                            title: window.$t("crs.task.activationTime"), field: 'activationTime', type: 6, isArray: true,
                            format: 'yyyy-MM-dd HH:mm:ss',
                            startEndParam: ['activationStartTime', 'activationEndTime']
                        },
                        {click: window.$t("common.search")},
                        {click: "导出"},
                        {click: "修改状态"},
                    ]
                },
                formData2: {
                    hasLable: true,
                    cols: [
                        {title: '主键', field: 'taskActivityId', hidden: true, data: this.$route.query.activityId},
                        {title: window.$t("crs.task.customerNo"), field: 'customer'},
                        {title: window.$t("crs.task.phone"), field: 'phone'},
                        {title: window.$t("crs.task.userStatus"), field: 'userStatus', type: 2, optionList: userStatus, isNumber: true},
                        {
                            title: window.$t("crs.task.awardDate"), field: 'awardSateDate', type: 6, isArray: true,
                            format: 'yyyy-MM-dd HH:mm:ss',
                            startEndParam: ['awardSateStartDate', 'awardSateEndDate']
                        },
                        {
                            title: window.$t("crs.task.openAccountDate"), field: 'openAccountStartDate', type: 6, isArray: true,
                            format: 'yyyy-MM-dd HH:mm:ss',
                            startEndParam: ['openAccountStartDate', 'openAccountEndDate']
                        },

                        {
                            title: window.$t("crs.task.activationTime"), field: 'activationTime', type: 6, isArray: true,
                            format: 'yyyy-MM-dd HH:mm:ss',
                            startEndParam: ['activationStartTime', 'activationEndTime']
                        },
                        {click: window.$t("common.search")},
                        {click: "导出"},
                    ]
                },
                formData3: {
                    hasLable: true,
                    cols: [
                        {title: '主键', field: 'taskActivityId', hidden: true, data: this.$route.query.activityId},
                        {title: window.$t("crs.task.customerNo"), field: 'customer'},
                        {
                            title: window.$t("crs.task.createDate"), field: 'time', type: 6, isArray: true,
                            format: 'yyyy-MM-dd HH:mm:ss',
                            startEndParam: ['startDate', 'endDate']
                        },
                        {click: window.$t("common.search")},
                        {click: window.$t("crs.task.blacklistImport")},
                    ]
                },
                formData4: {
                    hasLable: true,
                    cols: [
                        {title: '主键', field: 'taskActivityId', hidden: true, data: this.$route.query.activityId},
                        {title: window.$t("crs.task.customerNo"), field: 'customer'},
                        {
                            title: window.$t("crs.task.createDate"), field: 'time', type: 6, isArray: true,
                            format: 'yyyy-MM-dd HH:mm:ss',
                            startEndParam: ['startDate', 'endDate']
                        },
                        {click: window.$t("common.search")},
                    ]
                },
                auditData: {
                    hasLable: true,
                    cols: [
                        {title: '主键', field: 'taskActivityId', hidden: true, data: this.$route.query.activityId},
                        {title: window.$t("crs.task.customerNo"), field: 'customer'},
                        {
                            title: window.$t("crs.task.achieveStatus"),
                            field: 'status',
                            type: 3,
                            optionList: activationStatus2,
                            isNumber: true
                        },
                    ]
                },
            }
        }
    }
</script>
<style lang="scss" scoped>
  .data_list {
    ul {
      display: flex;
      justify-content: space-between;
      align-items: center;

      li {
        text-align: center;

        div {
          font-size: 26px;
          color: #333;
        }

        span {
          font-size: 14px;
          color: #999;
        }
      }
    }
  }

  ul,
  li {
    list-style: none;
  }
</style>
